<app-search-type-edict></app-search-type-edict>
